import { type ReactNode } from 'react';
import { AccountDashboardMain } from '../AccountDashboard/AccountDashboardMain';

export const SecurityPage = ({ children }: { children: ReactNode }) => (
  <AccountDashboardMain title="Security">{children}</AccountDashboardMain>
);
